import { SET_ROLES_AND_RIGHTS } from "../constants/index";

const initialState = {
  userRights: [],
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ROLES_AND_RIGHTS:
      return {
        ...state,
        userRights: [...state.userRights, ...action.roles],
      };
    default: {
      return state;
    }
  }
};
export default roleReducer;
